import i18n from '@opsbase/lib-i18n';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import OpTypePicker from '@opsbase/web-pickers/OpTypePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Switch from '@opsbase/web-ui/Switch';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function AboutSettingsSection(props) {
    const { definition, isEditable = false, onChange, isOpDefLocked } = props;
    const handleFieldUpdate = useCallback(field => value => onChange === null || onChange === void 0 ? void 0 : onChange({ [field]: value }), [onChange]);
    return (React.createElement(Vertical, { gutter: true, padding: true },
        React.createElement(Horizontal, { gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
            React.createElement(Text, { variant: "h1" }, i18n.t('about')),
            React.createElement(Text, { color: "grey" }, i18n.t('select-about'))),
        React.createElement(Card, { padding: true },
            React.createElement(Vertical, { paddingY: true, gutter: true },
                React.createElement(Pane, null,
                    React.createElement(Switch, { disabled: !isEditable, checked: definition.enabled, onChange: handleFieldUpdate('enabled'), label: i18n.t('enabled-opdef-description'), tip: i18n.t('enabled-opdef-helptext') })),
                React.createElement(Horizontal, { justify: "flex-start", centered: true, gutter: true },
                    React.createElement(OpTypePicker, { style: { minWidth: 200 }, disabled: !isEditable || isOpDefLocked, noMargin: true, white: true, value: definition.type, onChange: handleFieldUpdate('type') }),
                    React.createElement(Text, { variant: 'h3' }, i18n.t('op-type-description'))),
                React.createElement(TextFieldWithStateAndBlur, { disabled: !isEditable || isOpDefLocked, white: true, noMargin: true, fullWidth: true, placeholder: i18n.t('op-description-enter'), value: definition.description, onBlur: handleFieldUpdate('description') })))));
}
export default AboutSettingsSection;
